import React, {useMemo} from "react";
import {observer} from "mobx-react-lite";
import {Table, TableBody, TableCell, TableRow} from "@mui/material";
import {useStores} from "../../../stores";
import {CurrencyComponent} from "../../../components/currency-component/CurrencyComponent";
import type {ColSpec} from "../../../components/table/MithraTableHeadColumns";
import {MithraTableHeadColumns} from "../../../components/table/MithraTableHeadColumns";
import type ProfileStore from "../../../stores/ProfileStore";
import {PartReCategorizationHandler} from "../../../components/categorization/PartRecategorizationHandler";
import {CategoryMenuController} from "../../categorization/context/CategoryMenuController";
import {MithraTableCell} from "../../../components/table/MithraTableCell";

//this was getCatReviewSubColumns
export function getDatasetTargetColumns(p: ProfileStore): ColSpec[] {
    const arr: (ColSpec | undefined)[] = [
        {cls: 'col-b_name', txt: p.buDataName, width: 125},
        {cls: 'col-s_name', txt: p.supplierDataName},
        {cls: 'col-p_name', txt: 'Part name'},
        {cls: 'col-p_description', txt: p.partDataDescription},
        {cls: 'col-p_spend', txt: 'Amount', width: 90},
    ]
    return arr.filter(c => c) as ColSpec[];
}

export const MappingResultTable: React.FC = observer(() => {
    const {p, categorizationReviewStore, dataIngestionStore} = useStores()
    const categories = categorizationReviewStore.categories;

    const controller = useMemo(() => {
        if (!categories.taxonomy_categories) {
            if (categories.taxonomy_categories === null) {
                console.error('No taxonomy set...')
            }
            return undefined
        }
        return new CategoryMenuController(categories.taxonomy_categories);
    }, [categories.taxonomy_categories])

    const isLoading = categorizationReviewStore.reviewPageController.isLoadingData;
    const tableClass = 'mithra-table x-design x-design-narrow' + (isLoading ? ' loading' : '');

    const data = dataIngestionStore.dataMappingResultTable;

    const COLUMNS = getDatasetTargetColumns(p)

    return <div className={tableClass}>
        {controller && <PartReCategorizationHandler controller={controller}/>}
        <Table cellPadding="0">
            <MithraTableHeadColumns columns={COLUMNS} enableLoading isLoading={isLoading}/>
            <TableBody className="categorization-review-table-body">
                {data ? <>
                        {data.map((row, i) => <React.Fragment key={i}>
                            <SingularCategorizationReviewRow part={row}/>
                        </React.Fragment>)}
                        {data.length === 0 &&
                            <TableRow className="no-data">
                                <TableCell colSpan={COLUMNS.length}>
                                    No data
                                </TableCell>
                            </TableRow>
                        }
                    </>
                    : <TableRow className="no-data-yet"/>
                }
            </TableBody>
        </Table>
    </div>
})

type Props = {
    part: any
};
export const SingularCategorizationReviewRow: React.FC<Props> = observer(({part}) => {
    const {p} = useStores();
    const COLUMNS = getDatasetTargetColumns(p);

    let i = 0;

    return <TableRow>
        {/*<MithraTableCell c={COLUMNS[i++]}>*/}
        {/*    {part.bu_id ? part.bu_id : 'N/A'}*/}
        {/*</MithraTableCell>*/}
        <MithraTableCell c={COLUMNS[i++]}>
            {part.bu_name ? part.bu_name : 'N/A'}
        </MithraTableCell>
        {/*<MithraTableCell c={COLUMNS[i++]}>*/}
        {/*    {part.s_id ? part.s_id : 'N/A'}*/}
        {/*</MithraTableCell>*/}
        <MithraTableCell c={COLUMNS[i++]}>
            {part.s_name ? part.s_name : 'N/A'}
        </MithraTableCell>
        {/*<MithraTableCell c={COLUMNS[i++]}>*/}
        {/*    {part.s_city ? part.s_city : 'N/A'}*/}
        {/*</MithraTableCell>*/}
        {/*<MithraTableCell c={COLUMNS[i++]}>*/}
        {/*    {part.p_id ? part.p_id : 'N/A'}*/}
        {/*</MithraTableCell>*/}
        <MithraTableCell c={COLUMNS[i++]}>
            {part.p_name ? part.p_name : 'N/A'}
        </MithraTableCell>
        {p.p.p_description_col_name !== false &&
            <MithraTableCell c={COLUMNS[i++]}>
                {part.p_description ? part.p_description : 'N/A'}
            </MithraTableCell>
        }
        <MithraTableCell c={COLUMNS[i++]}>
            <CurrencyComponent v={part.p_spend}></CurrencyComponent>
        </MithraTableCell>
        {/*<MithraTableCell c={COLUMNS[i++]}>*/}
        {/*    {part.p_context_1 ? part.p_context_1 : 'N/A'}*/}
        {/*</MithraTableCell>*/}
        {/*<MithraTableCell c={COLUMNS[i++]}>*/}
        {/*    {part.p_purchase_date ? part.p_purchase_date : 'N/A'}*/}
        {/*</MithraTableCell>*/}
        {/*<MithraTableCell c={COLUMNS[i++]}>*/}
        {/*    {part.p_quantity ? part.p_quantity : 'N/A'}*/}
        {/*</MithraTableCell>*/}
        {/*<MithraTableCell c={COLUMNS[i++]}>*/}
        {/*    {part.p_in_l1 ? part.p_in_l1 : 'N/A'}*/}
        {/*</MithraTableCell>*/}
        {/*<MithraTableCell c={COLUMNS[i++]}>*/}
        {/*    {part.p_in_l2 ? part.p_in_l2 : 'N/A'}*/}
        {/*</MithraTableCell>*/}
        {/*<MithraTableCell c={COLUMNS[i++]}>*/}
        {/*    {part.p_in_l3 ? part.p_in_l3 : 'N/A'}*/}
        {/*</MithraTableCell>*/}
    </TableRow>
})